import { useMutation, useQuery } from 'react-query'
import { getErrorString } from 'src/utils'
import { getOrganizations, getOrganization } from './api'
import { toast } from 'sonner'

// prettier-ignore
export const keys = {
  all: ['ORG_KEYS'] as const,
  getOrganizations: () => [...keys.all, 'GET_ORGANIZATIONS'] as const,
  getOrg: (orgId: string) => [...keys.all, 'GET_ORG', orgId] as const,
}

export function useGetOrganizations(
  params: Parameters<typeof getOrganizations>[0],
) {
  return useQuery(keys.getOrganizations(), () => getOrganizations(params), {
    onError: (error) => {
      toast.error(getErrorString(error))
    },
  })
}

export function useGetOrganization(
  params: Parameters<typeof getOrganization>[0],
) {
  return useQuery(
    keys.getOrg(params.organization),
    () => getOrganization(params),
    {
      onError: (error) => {
        toast.error(getErrorString(error))
      },
    },
  )
}

export function useGetOrganizationMutation() {
  return useMutation(getOrganization, {
    onError: (error) => {
      toast.error(getErrorString(error))
    },
  })
}
